export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (edit_user, roles, users) {pug_mixins["options"] = pug_interp = function(available, selected){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate (available)
;(function(){
  var $$obj = (available);
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var v = $$obj[pug_index0];
pug_html = pug_html + "\u003Coption" + (pug_attr("value", v, true, true)+pug_attr("selected", (v == selected), true, true)) + "\u003E" + (pug_escape(null == (pug_interp = v) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

};


























pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (users) {
pug_html = pug_html + "\u003Cdiv\u003E\u003Ctable class=\"users\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EUsername\u003C\u002Fth\u003E\u003Cth\u003ERole\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003Ctbody\u003E\u003C\u002Ftbody\u003E";
// iterate users
;(function(){
  var $$obj = users;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var user = $$obj[pug_index3];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = user.username) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = user.role) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca" + (" class=\"edit\""+" href=\"#\""+pug_attr("data-user", user, true, true)) + "\u003Eedit\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var user = $$obj[pug_index3];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = user.username) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = user.role) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca" + (" class=\"edit\""+" href=\"#\""+pug_attr("data-user", user, true, true)) + "\u003Eedit\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fthead\u003E\u003C\u002Ftable\u003E\u003Cbutton class=\"add-user\"\u003EAdd user\u003C\u002Fbutton\u003E\u003Cform" + (pug_attr("class", pug_classes(["editor","with-validation",{"display-none": edit_user == null}], [false,false,true]), false, true)+" autocomplete=\"off\"") + "\u003E\u003Chr\u003E\u003Cdiv class=\"fields\"\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"username\""+pug_attr("value", (edit_user && edit_user.username), true, true)+" placeholder=\"Username\"") + "\u003E\u003Cinput class=\"form-control\" type=\"password\" name=\"password\" placeholder=\"Password\"\u003E\u003Cinput class=\"form-control\" type=\"password\" name=\"password2\" placeholder=\"Repeat password\"\u003E\u003Cselect class=\"form-control\" name=\"role\"\u003E";
pug_mixins["options"](roles, edit_user && edit_user.role);
pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"save-user\"\u003ESave\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"edit_user" in locals_for_with?locals_for_with.edit_user:typeof edit_user!=="undefined"?edit_user:undefined,"roles" in locals_for_with?locals_for_with.roles:typeof roles!=="undefined"?roles:undefined,"users" in locals_for_with?locals_for_with.users:typeof users!=="undefined"?users:undefined));;return pug_html;}